<script>
import { changeUserStatus } from '@/api/user.js';
import RoleUserTag from '@/components/page-user-edit/RoleUserTag.vue';
import { formatMinskTimestamp } from '@/scripts/tools.js';

export default {
    components: {
        RoleUserTag: RoleUserTag,
    },
    props: {
        user: Object,
    },
    methods: {
        formatMinskTimestamp,
        async toggleUserStatus(status) {
            const response = await changeUserStatus(this.user.id, status);
            if (response === true) {
                this.$store.commit('USER_SET_DATA', {
                    id: this.user.id,
                    isActive: !this.user.is_active,
                });
            }
        },
        formatDownloads(user) {
            // Handle null antifraud_snapshot
            if (
                !user.antifraud_snapshot ||
                user.antifraud_snapshot.total_downloaded_images == null
            ) {
                return '0';
            }

            const count = user.antifraud_snapshot.total_downloaded_images;

            // Format with thousands separator
            return count.toLocaleString('en-US');
        },
        getSubscriptionDisplay(user) {
            if (!user.subscription) {
                return 'No Subscription';
            }
            return user.subscription.plan.name;
        },
        getSubscriptionStatus(user) {
            if (!user.subscription) {
                return null;
            }
            return user.subscription.status;
        },
    },
};
</script>

<template>
    <tr>
        <th class="th_center">
            <router-link
                :to="{ name: 'userEditWithId', params: { userId: user.id } }"
                class="user_link"
            >
                {{ user['id'] }}
            </router-link>
        </th>
        <th class="th_center th_160">
            <button
                v-if="user['is_active'] === false"
                @click="toggleUserStatus(true)"
                class="toggle_button_150 button_unactive"
            >
                Disable
            </button>
            <button
                v-else
                @click="toggleUserStatus(false)"
                class="toggle_button_150 button_active"
            >
                Active
            </button>
        </th>
        <th class="th_center">
            <router-link
                :to="{ name: 'userEditWithId', params: { userId: user.id } }"
                class="user_link"
            >
                <RoleUserTag :roleID="user['user_role_id']" />
            </router-link>
        </th>
        <th>
            <router-link
                :to="{ name: 'userEditWithId', params: { userId: user.id } }"
                class="user_link"
            >
                {{ user['name'] }}
            </router-link>
        </th>
        <th>
            <router-link
                :to="{ name: 'userEditWithId', params: { userId: user.id } }"
                class="user_link"
            >
                {{ user['email'] }}
            </router-link>
        </th>
        <th>
            <router-link
                :to="{ name: 'userEditWithId', params: { userId: user.id } }"
                class="user_link"
            >
                {{ user['company'] }}
            </router-link>
        </th>
        <th>
            <router-link
                :to="{ name: 'userEditWithId', params: { userId: user.id } }"
                class="user_link"
            >
                {{ formatMinskTimestamp(user.created_at) }}
            </router-link>
        </th>
        <th class="th_center">
            <router-link
                :to="{ name: 'userEditWithId', params: { userId: user.id } }"
                class="user_link"
            >
                {{ formatDownloads(user) }}
            </router-link>
        </th>
        <th class="th_center">
            <router-link
                :to="{ name: 'userEditWithId', params: { userId: user.id } }"
                class="user_link"
            >
                <span
                    class="subscription_badge"
                    :class="[
                        getSubscriptionStatus(user)
                            ? `status_${getSubscriptionStatus(user)}`
                            : 'status_none',
                    ]"
                >
                    {{ getSubscriptionDisplay(user) }}
                </span>
            </router-link>
        </th>
    </tr>
</template>

<style scoped>
.user_link {
    color: inherit;
    text-decoration: none;
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.user_link:hover {
    opacity: 0.8;
}

.subscription_badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 500;
}

.status_active {
    background-color: #d1fae5;
    color: #065f46;
}

.status_trialing {
    background-color: #dbeafe;
    color: #1e40af;
}

.status_past_due,
.status_unpaid {
    background-color: #fee2e2;
    color: #991b1b;
}

.status_cancelled {
    background-color: #f3f4f6;
    color: #4b5563;
}

.status_none {
    background-color: #f9fafb;
    color: #6b7280;
    font-style: italic;
}
</style>
